import { useContext } from 'react';
import { useGetGuiasMerchandising } from '../../../lib/react-query/fileQuery';
import SkeletonLoader from '../../common/SkeletonLoader';
import MerchandisingCard from './MerchandisingCard';
import NewMerchandisingCard from './NewMerchandisingCard';
import { UserContext } from '../../../context/UserProvider';

const FilesMerchandising = () => {
  const { data: guias, isLoading } = useGetGuiasMerchandising();
  const { userRole } = useContext(UserContext);

  return (
    <>
      {isLoading ? (
        <div className="grid-container">
          <SkeletonLoader totalColumns={4} minHeight="85px" />
        </div>
      ) : (
        <div className="grid-container grid-container__overflow">
          {guias?.data?.map((guia) => (
            <MerchandisingCard key={guia._id} file={guia} />
          ))}
          {userRole === 'MasterAdmin' && <NewMerchandisingCard />}
        </div>
      )}
    </>
  );
};

export default FilesMerchandising;
